var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('app-list-item',{attrs:{"value":_vm.value}},[_c('field-basic-data',{attrs:{"data":_vm.basicData,"refuel":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }